import { createAction } from '@reduxjs/toolkit';

const saveJourneyFormValues = createAction('ui/sealink/journey/saveFormValues');
const setJourneyDates = createAction('ui/sealink/journey/setJourneyDates');
const setJourneys = createAction('ui/sealink/journey/setJourneys');
const setSegmentStop = createAction(
  'ui/sealink/journey/setSegmentStop',
  (segmentId, journeyIndex, segmentStop) => ({
    payload: {
      segmentId,
      journeyIndex,
      segmentStop,
    },
  })
);
const setOneSegmentStop = createAction(
  'ui/sealink/journey/setOneSegmentStop',
  ({ segmentId, journeyIndex, segmentStop, isStartingPoint }) => ({
    payload: {
      segmentId,
      journeyIndex,
      segmentStop,
      isStartingPoint,
    },
  })
);

const clearForwardPreselect = createAction(
  'ui/sealink/journey/clearForwardPreselect'
);
const clearReturnPreselect = createAction(
  'ui/sealink/journey/clearReturnPreselect'
);

const setServicePreselect = createAction(
  'ui/sealink/journey/setServicePreselect'
);

export {
  saveJourneyFormValues,
  setJourneyDates,
  setJourneys,
  setSegmentStop,
  setOneSegmentStop,
  clearForwardPreselect,
  clearReturnPreselect,
  setServicePreselect,
};
